import HttpService from "@core/services/http/http.service";
import {
  GetListAuthorFqaRequest,
  GetListAuthorFqaResponse,
} from "@app/types/author-fqa.type";
import { Signal } from "@core/services/http/http.type";

class AuthorFqasService {
  public getList(
    requestParams?: GetListAuthorFqaRequest,
    signal?: Signal,
    isShowLoading?: boolean,
  ) {
    return HttpService.get<GetListAuthorFqaResponse>(
      "/admin/api/v3/author-fqas",
      {
        queryParams: { ...requestParams },
        signal,
        isShowLoading,
      },
    );
  }
}

export default new AuthorFqasService();
